var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.14673 4.92651L7.43117 8.21096L10.7156 4.92651","stroke":"white","strokeWidth":"1.09481","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Chevron.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
